Monitoring.Views.Dashboards ||= {}

class Monitoring.Views.Dashboards.ReprocessView extends Backbone.View
  template: JST["backbone/templates/monitoring/dashboards/reprocess"]

  events:
    'click #update': 'update'
    'click #cancel': 'cancel'
    'click #close': 'cancel'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @currentUser = @options.currentUser
    @contentsTotal = 0
    @

  addTags:()=>
    tags = @tagsModel.allPossibleTags
    @tagsToBeAdded.render()
    @tagsToBeAdded.addSelectableTags(tags, I18n.t('monitoring.massive_actions.massive_tagging.add_tags'))
    @$('#add_tags').append(@tagsToBeAdded.el)
    @tagsToBeRemoved.render()
    @tagsToBeRemoved.addSelectableTags(tags, I18n.t('monitoring.massive_actions.massive_tagging.remove_tags'))
    @$('#remove_tags').append(@tagsToBeRemoved.el)

  setAddTags: (tags) ->
    @addTagsView.setList(tags)
    @addTagsView.setTagsByClientCode([])
    @addTagsView.render()

  addModalBody: (hash) =>
    @options_view = new Monitoring.Dashboard.SelectableOptionsView(hash)
    @$('.modal-body').append( @options_view.render().el)

  selectedOptions:()=>
    @options_view._selectedFromHash(@hash)

  setOnFinish: (callback) ->
    @onFinish = callback

  onFailure: =>
    document.body.style.cursor = 'default'
    @$el.find("#update, #cancel, #close").prop( "disabled", false )
    @$el.find('#update').addClass('warning').text('Update failed, retry?')
    showError("An unexpected error has occurred. Please contact us if this error persists.")

  resetUpdateButton: ->
    @$el.find('#update').removeClass('warning').text('Update')

  show: ->
    @$el.html(@template({contentsTotal: @contentsTotal}))
    $(@$el).append(@modalElement) if @modalElement
    @modalElement = ''
    @$el.find('#update_all').modal()
    @render()

  hide: (shouldClearStatus = true) ->
    @$el.find('#update_all').modal('hide')

  render: ->
    @hash = {'maintain_user_tagging_actions': 'maintain_user_tagging_actions', 'keep_original_sentiment': 'keep_original_sentiment', 'keep_original_decision': 'keep_original_decision'}
    @addModalBody(@hash)
    return this

  update: =>
    title = @contentsTotal + ' contents will be reprocessed. Are you sure you want to reprocess them?'
    swal({
      title: title,
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn-info',
      confirmButtonText: 'Yes, update all',
      closeOnConfirm: true
    }, =>
      reprocess_options = {
        options_selected:  @selectedOptions()
      }
      @hide(true)
      @_sendRequest(_.extend(reprocess_options: reprocess_options, current_user: @currentUser))
    )

  cancel: ->
    @hide(false)

  _sendRequest: (params) ->
    updateJob = new Monitoring.Methods.AsyncJob()
    updateJob.bind('completed', @onFinish)
    updateJob.bind('failed', @onFailure)
    params.searchQuery = @searchQuery.toJSON()
    updateJob.start 'contents_reprocess', params

  setReachedDocument: (documents_count) ->
    @reached_documents = documents_count
    @render()
